import React from "react";
import PdfListPage from "./PdfListPage";
import { usePoly } from "./PolyLayout";

export default function Admissions() {
  const data = usePoly();
  return (
    <PdfListPage
      eyebrow="Join Us"
      title="Admission Notices"
      accent="coral"
      items={data.notices_admission || []}
      testid="poly-admissions"
      emptyMsg="Admission notices will appear here once published."
    />
  );
}
